var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"show-tag-columns":"","show-tag-filter":"","list":_vm.list,"columns":_vm.templateListColumns || _vm.columns,"single-actions":_vm.singleActions,"group-actions":_vm.groupActions,"export-data-options":_vm.exportDataOptions,"show-page":!_vm.isTemplate}})
}
var staticRenderFns = []

export { render, staticRenderFns }